import { render, staticRenderFns } from "./email-template-editor.vue?vue&type=template&id=c00c8b20&scoped=true&"
import script from "./email-template-editor.vue?vue&type=script&lang=ts&"
export * from "./email-template-editor.vue?vue&type=script&lang=ts&"
import style0 from "./email-template-editor.vue?vue&type=style&index=0&id=c00c8b20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00c8b20",
  null
  
)

export default component.exports